/**
 * Just prints objects in pretty format.
 * Needed to prevent console from lying on object properties (by making snapshots of objects)
 * */
const prettyDebug = (
  v: Record<string, unknown>,
): string | Record<string, unknown> => {
  try {
    return JSON.stringify(v, undefined, 4);
  } catch (e) {
    console.error(e);
    return v;
  }
};

export default prettyDebug;
